import axiosInstance from ".";

export const columnListApi = (pageNum: number, searchKnd: string, searchKeyword: string) => axiosInstance.get(`/mtlthrpy/column/columnList.do?nowPage=${pageNum}&searchKnd=${searchKnd}&searchKeyword=${searchKeyword}`);

export const columnDetailApi = (contentSeq: number) => axiosInstance.get(`/mtlthrpy/column/columnDetail.do?contentSeq=${contentSeq}`)